import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { CFAttachmentFile } from '../../models/attachments/cf-attachment-file';

@Injectable({ providedIn: 'root' })
export class CFAttachmentService {
    private apiUrl = environment.apiUrl + '/api/documents';

    constructor(private http: HttpClient) {}

    downloadFile(documentType: number, companyId: string, externalId: string, ipfsId: string): Observable<Blob> {
        return this.http.get(`${this.apiUrl}/${documentType}/${companyId}/${externalId}/attachments/${ipfsId}`, {
            responseType: 'blob'
        });
    }

    getAttachments(documentType: number, companyId: string, externalId: string): Observable<Array<CFAttachmentFile>> {
        return this.http.get<Array<CFAttachmentFile>>(`${this.apiUrl}/${documentType}/${companyId}/${externalId}/attachments`);
    }
}
